export enum LeoComparisonPeriod {
  WEEKLY = 'weekly',
  MONTHLY = 'monthly',
  SELECT_DATE = 'select_date',
}
